import { allCaregiverRoles, TraineeTeamRole } from 'types'

export const getRolesList = (roles: TraineeTeamRole[] | null | undefined, otherRole: string) => {
  const safeRoles = roles ?? []
  return safeRoles
    .map((role) => {
      if (role === TraineeTeamRole.other) {
        return otherRole || ''
      }

      const roleItem = allCaregiverRoles.find((roleItem) => roleItem.value === role)

      return roleItem?.label || role
    })
    .filter((role) => role !== '')
}
